// extracted by mini-css-extract-plugin
export var fixed = "_9C_ckk";
export var header = "_9C_clk";
export var header_hamb = "_9C_cpk";
export var header_link = "_9C_cmk";
export var header_title = "_9C_cnk";
export var home = "_9C_bjk";